import React from 'react';
import Loader from '../Spinner/Loader';
import { Button } from 'react-bootstrap';

type IProps = {
  loading?: boolean;
  btnText?: string;
};
const CommonFormBtn = ({ loading, btnText }: IProps) => {
  return (
    <div className='form-group col-md-12 mb-3 mt-3 text-end'>
      {loading ? (
        <Loader css={'btn w-100'} />
      ) : (
        <Button type='submit' className='submit-button common-btn'>
          {btnText || 'Submit'}
        </Button>
      )}
    </div>
  );
};

export default CommonFormBtn;
